import {Record as ImmutibleRecord} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';

type LikeMap = Record<string, boolean | undefined>;

export class ActivitiesState extends ImmutibleRecord<{likeMap: LikeMap; submittingComment: boolean}>({
    likeMap: {},
    submittingComment: false,
}) {}

const setLiking = (state: ActivitiesState, id: string, liking: boolean | undefined) =>
    state.merge({
        likeMap: {
            ...state.likeMap,
            [id]: liking,
        },
    });

export default makeReducer<ActivitiesState>(
    [
        match(Actions.likeComment, (state, action) => {
            return setLiking(state, action.payload.commentId, !action.payload.liked);
        }),
        match(Actions.likeCommentFailed, (state, action) => {
            return setLiking(state, action.payload.commentId, undefined);
        }),
        match(Actions.likeActivity, (state, action) => {
            return setLiking(state, action.payload.activityId, !action.payload.liked);
        }),
        match(Actions.likeActivityFailed, (state, action) => {
            return setLiking(state, action.payload.activityId, undefined);
        }),
        match(Actions.clearLikeMap, (state, action) => {
            return setLiking(state, action.payload.id, undefined);
        }),
        match(Actions.comment, state => {
            return state.merge({submittingComment: true});
        }),
        match(Actions.commentSuccess, state => {
            return state.merge({submittingComment: false});
        }),
        match(Actions.commentFailed, state => {
            return state.merge({submittingComment: false});
        }),
    ],
    new ActivitiesState(),
);
